module.exports = __webpack_public_path__ + "img/Desert.30f5aaa0.png";